<template>
  <club-layout>
    <panel-blue /> 
    <div id="container"></div>
  </club-layout>
</template>


<script>
import PanelBlue from './panels/PanelBlue/PanelBlue';

export default {
  name: 'PageClubTerminalList',
  components: {
    PanelBlue,
  }
}
</script>

<style scoped>
  #container {
    margin-top: 20px;
  }
</style>
